import * as actionTypes from './actionTypes';
import axios from 'axios';

export const addIngredients = igtype => {
    return {
        type: actionTypes.ADD_INGREDIENT,
        payload: igtype,
    }
}

export const removeIngredients = igtype => {
    return {
        type: actionTypes.REMOVE_INGREDIENT,
        payload: igtype,

    }
}

export const resetIngredients = () => {
    return { type: actionTypes.RESET_INGREDIENT }
}

const orderLoadSuccess = orders => {
    return {
        type: actionTypes.ORDER_LOAD_SUCCESS,
        payload: orders
    }
}
const orderLoadFailed = errMsg => {
    return {
        type: actionTypes.ORDER_LOAD_FAILED,
        payload: errMsg,
    }
}

export const fetchOrders = (token, userId) => dispatch => {
    const queryParams = '&orderBy="userId"&equalTo="' + userId + '"'
    axios.get('https://burger-builder-983fd-default-rtdb.firebaseio.com/orders.json?auth=' + token + queryParams)
        .then(response => {
            dispatch(orderLoadSuccess(response.data))
        })
        .catch(err => {
            dispatch(orderLoadFailed(err.message))
        })
}